import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error("Not signed in. Please log in.");
  }

  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

export async function fetchImportBatches() {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/admin/import-batches`, {
    method: "GET",
    headers,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Could not load batches (${res.status}).`);
  }
  return data.batches ?? [];
}

export async function fetchImportBatchDetail(batchId) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/admin/import-batches/${batchId}`, {
    method: "GET",
    headers,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Could not load batch (${res.status}).`);
  }
  return { batch: data.batch, sources: data.sources ?? [] };
}

/**
 * @param {{
 *   archiveGraceHours?: number,
 *   crossSourceDedupe?: boolean,
 *   allowLlmFallback?: boolean,
 *   writeOnlyIfDryOk?: boolean,
 * }} payload
 */
/**
 * Re-run replay write only for sources where dry succeeded but write failed (same batch).
 *
 * @param {string} batchId
 * @returns {Promise<{ batchId: string; retriedSourceCount: number }>}
 */
export async function retryImportBatchWrite(batchId) {
  const headers = await authHeaders();
  const res = await fetch(
    `${API_BASE}/api/admin/import-batches/${batchId}/retry-write`,
    {
      method: "POST",
      headers,
      body: "{}",
    }
  );
  const data = await res.json().catch(() => ({}));
  if (res.status !== 202 && !res.ok) {
    throw new Error(
      data.error || `Could not retry batch write (${res.status}).`
    );
  }
  return {
    batchId: data.batchId ?? batchId,
    retriedSourceCount: data.retriedSourceCount ?? 0,
  };
}

export async function startImportAllSources(payload = {}) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/admin/import-batches`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      archiveGraceHours: payload.archiveGraceHours,
      crossSourceDedupe: payload.crossSourceDedupe !== false,
      allowLlmFallback: payload.allowLlmFallback !== false,
      writeOnlyIfDryOk: payload.writeOnlyIfDryOk !== false,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (res.status !== 202 && !res.ok) {
    throw new Error(data.error || `Could not start batch (${res.status}).`);
  }
  if (!data.batchId) {
    throw new Error(data.error || "Missing batch id.");
  }
  return data.batchId;
}
